// extracted by mini-css-extract-plugin
module.exports = {"container_cab":"cab_container_cab__3FaIh","section":"cab_section__1_yeC","title":"cab_title__397QM","square_title":"cab_square_title__NFAMT","label_title":"cab_label_title__1FJ_V"};